export default __webpack_public_path__ + "static/media/MaterialIconsSharp-Regular.d42c99c9.ttf";